export default __webpack_public_path__ + "static/media/charts.8fa6d293.png";